.character-info-container {
  max-width: 96rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.container {
  height: 100%;
  display: flex;
  gap: 1.6rem;
  padding-top: 1.6rem;
}

.side-info {
  border-right: 1px solid var(--color-grey-7);
  padding-right: 1.6rem;
  flex: 1 1 0;
  min-width: 33.6rem;
}

.main-info {
  flex: 2 0 auto;
}

.uploader-container {
  width: 32rem;
  height: 32rem;
  margin-bottom: 1.6rem;
}

.character-name {
  margin: 0 0 0.4rem;
}

.info-label {
  line-height: 2rem;
}

.character-info-title {
  margin-bottom: 1.6rem;
}

.row {
  display: flex;
  gap: 4rem;
}

.field-container {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  min-width: 46rem;
  max-width: 46rem;
  min-height: 4.6rem;

  & > div {
    margin-left: -0.8rem;
  }

  // The -0.8rem above cancels InlineTextArea's own 0.8rem padding so its text lines up with
  // the label. InlineEditableText already insets itself by its 1.2rem padding, so it needs no
  // pull-left of its own.
  & > .number-field {
    margin-left: 0;
  }
}

.line {
  margin: 1.6rem 0;
  border: 0.1rem solid var(--color-grey-7);
}
